import { AnchorButton } from "@blueprintjs/core";
import React from "react";
import { niceDateTime, yearFromNow } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";

class SxMaster extends React.Component {
  state = {
    changed: false,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }

  render() {
    return (
      <>
        <td>{this.props.data.entityName}</td>
        <td>{this.props.data.patientGenericPid}</td>
        <td>{this.props.data.patientName}</td>

        <td>{yearFromNow(this.props.data.patientDob)}</td>
        <td>{this.props.data.patientSex}</td>
        <td>
          {this.props.data.lineItems
            .map((each) => {
              if (each.lineItemType === "SX") {
                return each.entityName;
              } else return null;
            })
            .filter(Boolean)
            .join(" , ")}
        </td>
        <td>{this.props.data.eye}</td>
        <td>
          {" "}
          {this.props.data.itemsNeededForSurgery
            .map((each) => {
              return each.entityName;
            })
            .filter(Boolean)
            .join(" , ")}
        </td>

        <td>{this.props.data.anaesthesiaType}</td>
        <td>{this.props.data.bookingRemarks}</td>
        <td>{this.props.data.diet}</td>

        <td>{this.props.data.site}</td>
        <td>{this.props.data.surgeonName}</td>

        <td>{niceDateTime(this.props.data.time)}</td>
        <td>{this.props.data.lifecycle}</td>
        <td>
          <AnchorButton
            outlined
            icon="document-share"
            href={`/sx/${this.props.data._id}`}
            target="_blank"
          />
        </td>
      </>
    );
  }
}

export default inject("authStore")(observer(SxMaster));
